<template>
  <div>
    <panel-block id="pn-label">
      <panel-item>
        <label :for="selectedPropertySection.idForProp('label')">Label</label>
        <expandable-textarea
          :id="selectedPropertySection.idForProp('label')"
          v-model="selectedPropertySection.label_title"
          placeholder="Enter a label..."
        />
      </panel-item>
    </panel-block>
  </div>
</template>


<script lang="ts">
import Vue from "vue";
import selectedMixin from "../mixins/selectedMixin";

export default Vue.extend({
  mixins: [selectedMixin],
});
</script>